/// <reference path="../modules/app.module.ts" />

module App {
    //interface IRemoveProductScope extends ng.IScope {
    //    product: any;
    //}

    interface IRemoveProduct extends ng.IDirective {

    }

    class RemoveProduct implements IRemoveProduct {
        static directiveId: string = "removeProduct";
        restrict: string = "A";

        constructor(private $compile: ng.ICompileService, private sessionService: Interfaces.ISessionService, private $rootScope: Interfaces.IAppRootScope) {
        }

        scope = {
            product: "=",
            removeFromBasket: "="
        };

        link = ($scope: any, element, attrs) => {

            element.on('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var content = '<div class="fancybox-skin" style="width: 300px;">Weet u zeker dat u \'' + $scope.product.name + '\' wilt verwijderen?<div><input id=\"fancyConfirm_cancel\" class="brandBgcolor popup-btn" type=\"button\" value=\"Annuleren\" onclick="$.fancybox.close(true);"><input id=\"fancyConfirm_ok\" class="brandBgcolor popup-btn" type=\"button\" value=\"Ok" ng-click="removeFromBasket(\'' + $scope.product.id + '\',\'' + $scope.product.name +'\');"></div></div>';
                var template = angular.element(content);
                var compiledTemplate = this.$compile(template);

                var options = {
                    content: template,
                    type: 'html',
                    width: '320',
                    autoSize: false,
                    maxWidth: 900
                };

                $.fancybox.open(["removeProduct"], options);

                compiledTemplate($scope);

            });
        }


        removeFromBasket = (product) => {
            if (confirm('Weet u zeker dat u ' + '\'' + product.name + '\' wilt verwijderen? ')) {
                var products = this.sessionService.composition.selectedProducts;

                var products = products.filter((p) => { return p.name == product.name; });

                    if (products.length > 0) {
                        var index = products.indexOf(products[0]);
                        products.splice(index, 1);

                        var tempComp = this.sessionService.composition;
                        tempComp.selectedProducts = products;
                        this.sessionService.composition = tempComp;

                        this.$rootScope.$broadcast(Constants.broadcast.shopcartUpdatedFromCart);
                    }
            }
        }
    }

    app.directive(RemoveProduct.directiveId, ['$compile', Services.SessionService.serviceId, '$rootScope', ($compile, sessionService, $rootScope) =>
        new RemoveProduct($compile, sessionService, $rootScope)
    ]);
}